/** @format */

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useTranslation } from 'react-i18next/hooks';

function Error(props) {
	const [t] = useTranslation('translation');

	//const paymentService = useStoreActions((actions) => actions.payment);
	const resultService = useStoreActions((actions) => actions.result);
	const travelSearchService = useStoreActions((actions) => actions.travelSearch);
	const travelsSelectService = useStoreActions((actions) => actions.travelsSelect);

	const paymentState = useStoreState((state) => state.payment);

	useEffect(() => {
		//paymentService.setError(null);
		resultService.setError(null);
		travelSearchService.setError(null);
		travelsSelectService.setError(null);
		// eslint-disable-next-line
	});

	return (
		<div>
			<section></section>
			<section>
				<h1>OOPS!</h1>
				<h3>{t('ErrorPageMessage')}</h3>
				{/* The API returns a translation key (e.g. unpaidNoShowFee) or plain text; unknown keys are shown as-is.
				    nsSeparator: false so a message containing ':' isn't read as a namespace. */}
				<h3 className='multiline' style={{ color: 'red' }}>{paymentState?.error?.errorMessage ? t(String(paymentState.error.errorMessage), { nsSeparator: false }) : null}</h3>
				<h3>
					{t('youCanTry')} <Link to='/'>{t('anotherAttempt')}</Link>.
				</h3>
				<h3>
					<a href='https://www.norled.no/kontakt-oss/'>{t('ContactInformation')}</a>.
				</h3>
			</section>
		</div>
	);
}

export default Error;
